export const SUPABASE_KEYS = {
  CONTRACTS: 'airtable_contracts_v2',
  CUSTOMER_ASSETS: 'airtable_customer_assets_v2',
  CUSTOMER_LOCATIONS: 'airtable_customer_locations_v2',
  TICKETS: 'hubspot_tickets_v2',
  COMPANIES: 'companies',
  USERS: 'users',
  SPARES: 'airtables_spares',
  SPARES_LOCATION: 'airtable_fsls_v2',
};
